import { TabBasedMultiCharts as AntdTabBasedMultiCharts } from "@empglabs/backoffice-ui-kit"

export const TabBasedMultiCharts = props => {
  return <AntdTabBasedMultiCharts {...props} />
}
